import IFormModel from "@/models/IFormModel";
import {Gender, UserCreateType} from "@/helpers/constants";
import {ValidationRule} from "@/declarations/ValidationRule";
import UserRules from "@/models/user/UserRules";

export default class UserCreate implements IFormModel {

	private static readonly defaultCountryCode = 'CH';

	public companyId: string | null = null;
	public userCreateType: UserCreateType | null = null;
	public gender: Gender | null = null;
	public firstname: string | null = null;
	public lastname: string | null = null;
	public countryCode: string = UserCreate.defaultCountryCode;
	public username: string | null = null;

	public timeZone: string = 'Europe/Zurich';
	public languageCode: string = 'de-CH';

	public reset(): void {
		this.companyId = null;
		this.userCreateType = null;
		this.gender = null;
		this.firstname = null;
		this.lastname = null;
		this.countryCode = UserCreate.defaultCountryCode;
		this.username = null;
	}

	public rules(property: string): ValidationRule[] {
		switch (property) {
			case 'companyId':
				return UserRules.companyIdRules;
			case 'userCreateType':
				return UserRules.userCreateTypeRules;
			case 'gender':
				return UserRules.genderRules;
			case 'firstname':
				return UserRules.firstnameRules;
			case 'lastname':
				return UserRules.lastnameRules;
			case 'countryCode':
				return UserRules.countryCodeRules;
			case 'username':
				return UserRules.usernameRules;
			default:
				return [];
		}
	}

}
